// extracted by mini-css-extract-plugin
export default {"root":"Header_root__okZWb","stuck":"Header_stuck__jpY5-","item":"Header_item__KNf0k","placeHolderShimmer":"Header_placeHolderShimmer__cIIy3"};